<template>
  <div v-bind="$attrs">
    <BaseShowEditDatePickerv2
      :date="isoDate"
      :label="label"
      :name="name"
      :edition-mode="editionMode"
      :required="required"
      :disable-date-picker="disabled"
      :errors="errors"
      @update:date="onDateUpdate"
    />
  </div>
</template>

<script>
import moment from 'moment'
import BaseShowEditDatePickerv2 from '@c/addf-package/components/BaseShowEditDatePicker/BaseShowEditDatePickerv2.vue'

/**
 * Crema's date picker contract (`v-model` as a `DD/MM/YYYY` string) on top of
 * FM's v-calendar picker, which speaks `YYYY-MM-DD`.
 */
export default {
  inheritAttrs: false,
  name: 'BaseShowEditDatePicker',
  components: { BaseShowEditDatePickerv2 },
  props: {
    editionMode: { type: Boolean, required: false, default: true },
    modelValue: { type: String, required: false, default: null },
    label: { type: String, required: false, default: null },
    name: { type: String, required: true },
    required: { type: Boolean, required: false, default: false },
    disabled: { type: Boolean, required: false, default: false },
    errors: { type: [Object, Array], required: false, default: null }
  },
  emits: ['update:modelValue', 'change'],
  computed: {
    isoDate() {
      const date = moment(this.modelValue, 'DD/MM/YYYY', true)
      return date.isValid() ? date.format('YYYY-MM-DD') : null
    }
  },
  methods: {
    onDateUpdate(value) {
      const date = moment(value, 'YYYY-MM-DD')
      const formatted =
        value && date.isValid() ? date.format('DD/MM/YYYY') : null
      this.$emit('update:modelValue', formatted)
      this.$emit('change', { attribute: this.name, value: formatted })
    }
  }
}
</script>
